import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { cn } from "@/lib/utils";

type EconomySimulatorSliderProps = {
  className?: string;
  thumbValue: number;
  thumbActiveClassName?: string;
  thumbInactiveClassName?: string;
  endText?: string;
} & React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>;

const EconomySimulatorSlider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  EconomySimulatorSliderProps
>(
  (
    {
      className,
      thumbValue,
      thumbActiveClassName = "bg-thopen-pink",
      thumbInactiveClassName = "bg-gray-500",
      endText,
      ...props
    },
    ref
  ) => {
    const max = props.max ?? 2050;
    const val = props.value?.[0] ?? 0;
    const showEndText = endText && val === max;
    const thumbColor =
      val > 0 ? thumbActiveClassName : thumbInactiveClassName;

    return (
      <SliderPrimitive.Root
        ref={ref}
        className={cn(
          "relative flex w-full touch-none select-none items-center",
          className
        )}
        {...props}
      >
        <SliderPrimitive.Track className="relative h-[0.875rem] w-full grow overflow-hidden rounded-full bg-gray-300/50">
          <SliderPrimitive.Range className="absolute h-full bg-gray-400/80" />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb
          className={cn(
            "flex h-[26px] min-w-[2.5rem] cursor-pointer items-center justify-center gap-2.5 rounded-lg px-2 py-1 shadow transition-colors focus-visible:outline-none focus-visible:ring-0 disabled:pointer-events-none disabled:opacity-50",
            thumbColor
          )}
          aria-label="Valor médio da conta"
        >
          <span className="whitespace-nowrap text-center text-xs font-bold text-white">
            {showEndText
              ? endText
              : thumbValue.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
          </span>
        </SliderPrimitive.Thumb>
      </SliderPrimitive.Root>
    );
  }
);
EconomySimulatorSlider.displayName = SliderPrimitive.Root.displayName;

export { EconomySimulatorSlider };
